<template>
  <div class="container">
    <el-row>
      <el-col :xs="24" :md="12" class="custom-card">
        <!-- عنوان بالای کارت -->

        <div class="card-title" v-if="userDetails && userDetails.length > 0">
          <span> اطلاعات مسئول چاه</span>
          <img src="/photo/local-user.svg" class="user-well-img" />
        </div>
        <!-- بدنه کارت -->
        <div
          class="box-user-details"
          v-for="item in userDetails"
          :key="'details' + item.id"
        >
          <!-- سطر اول -->
          <div class="user-row">
            <span> <strong>نام مسئول:</strong> {{ item.name }} </span>
            <span>
              <strong>کد شناسایی :</strong> {{ item.national_code }}
            </span>
          </div>

          <!-- سطر دوم -->
          <div class="user-row">
            <span>
              <strong>آخرین زمان آنلاین بودن:</strong>
              {{ item.last_login ?? "عدم بازدید" }}
            </span>
            <span>
              <strong> شماره تماس:</strong> {{ item.mobile + "  " }}
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- بخش‌های بالایی -->
    <el-row :gutter="20" class="top-section">
      <!-- کنترل لحظه‌ای -->
      <el-col :xs="24" :md="8" class="custom-card">
        <!-- <div class="card-title">
          <span>کنترل لحظه ای </span>
          <img src="/photo/real_time_title.svg" />
        </div>-->

        <el-card shadow="hover">
          <div class="card-content">
            <!-- سوییچ + متن زیر آن -->
            <div class="switch-wrapper">
              <el-switch :model-value="pumpStatus" @click="offOnMotor" />
              <div class="switch-label" :style="pumpStatus ? '' : 'color:red'">
                {{ pumpStatus ? "روشن" : "خاموش" }}
              </div>
            </div>

            <!-- اطلاعات پمپ -->
            <div class="pump-info">
              <span class="card-title">کنترل لحظه ایی </span>
              <img src="/photo/hugeicons_water-pump.svg" class="pump-icon" />
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- برنامه‌ریزی -->
      <el-col :xs="24" :md="8" class="custom-card">
        <!--<div class="card-title">
          <span>برنامه‌ریزی هفتگی </span>
          <img src="/photo/program_title.svg" />
        </div>-->
        <el-card shadow="hover">
          <div class="card-content">
            <el-button type="primary" @click="FunShowProgram"
              >برنامه‌ریزی</el-button
            >
            <div class="pump-info">
              <span class="card-title"> برنامه ریزی </span>
              <img src="/photo/program_title.svg" class="pump-icon" />
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- اثرانگشت -->
      <el-col :xs="24" :md="8" class="custom-card">
        <!--<div class="card-title">
          <span> اثرانگشت </span>
          <img src="/photo/program_title.svg" />
        </div>-->
        <el-card shadow="hover">
          <div class="card-content">
            <el-button type="primary" @click="FingerDialogVisible = true"
              >اثرانگشت</el-button
            >
            <div class="pump-info">
              <span class="card-title"> اثرانگشت </span>
              <img src="/photo/fingerprint.svg" class="pump-icon" />
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div class="card-title" style="display: block; text-align: right">
      ساعت های برنامه ریزی شده
    </div>
    <!-- جدول برنامه -->
    <div v-loading="tableData == null"></div>
    <div ref="tableWrapper" class="table-wrapper" v-if="!isMobile && tableData">
      <el-table :data="[tableData[0]]" border style="width: 100%">
        <el-table-column
          v-for="day in orderedDays"
          :key="day"
          :label="tableData[0][day]?.dayName || 'نامشخص'"
        >
          <template #default="{ row }">
            <div
              v-if="row[day]?.periods?.length"
              style="display: flex; flex-direction: column; gap: 4px"
            >
              <el-button
                v-for="(period, idx) in row[day].periods"
                :key="idx"
                size="small"
                class="time-button"
                @click="handleRemoveProgram(idx, day, period)"
              >
                {{ period.startTime }} - {{ period.endTime }}
              </el-button>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="isMobile" v-loading="groupedForMobile == null">
      <el-collapse
        v-model="activeCollapseKeys"
        class="mobile-schedule"
        accordion
      >
        <el-collapse-item
          v-for="(entries, key) in groupedForMobile"
          :key="key"
          :name="key"
          :title="key"
          class="mobile-collapse-item"
        >
          <ul class="time-list">
            <li
              v-for="(item, index) in entries"
              :key="index"
              class="time-button"
              @click="handleRemoveProgram(index, item.day, item)"
            >
              {{ item.startTime }} تا {{ item.endTime }}
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
    <!-- دکمه‌های خروجی -->
    <div class="export-buttons">
      <el-button @click="exportExcel">خروجی اکسل</el-button>
      <el-button @click="exportImage">خروجی عکس</el-button>
    </div>
    <ConfirmDialog
      v-model="dialogVisible"
      :title="title"
      :message="message"
      :activeDevice="deviceStore.activeDevice"
      :autoClose="true"
      :type="type"
      :dialogData="dialogData"
      @confirmed="onConfirm"
      ref="dialogRef"
    />
    <FingerPrintDialog
      v-model="FingerDialogVisible"
      :activeDevice="deviceStore.activeDevice"
      :autoClose="true"
      @confirmed="onConfirmFingerPrint"
      ref="dialogFingerRef"
    />
    <PumpProgram
      v-model="showProgramDialog"
      ref="programdialogRef"
      :activeDevice="deviceStore.activeDevice"
      v-model:programList="tableData"
      @confirmed="handleConfirmProgram"
    />
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
  watch,
  reactive,
} from "vue";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { showToast } from "@/utils/toastHelper";

import { fetchProgramList, getWellUserDetails } from "@/services/auth";
import { useDeviceStore } from "@/stores/device";
import { useAuthStore } from "@/stores/auth";
import ConfirmDialog from "@/components/ConfirmSocketDialog.vue";
import FingerPrintDialog from "@/components/FingerPrint.vue";
import PumpProgram from "@/components/PumpProgram.vue";
import socket from "@/services/socket";

const deviceStore = useDeviceStore();
const authStore = useAuthStore();
const orderedDays = [ 6, 0, 1, 2, 3, 4,5];
const week_days = ["یکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنج‌شنبه","جمعه","شنبه"];
socket.on("401", (data) => {
  showToast("اخطار:عدم دسترسی", "error");
  console.log(data);
});
/*socket.on("motor/status", (data) => {
  if(data.status==2)
    return
  if(title.value!=null)
  return
  pumpStatus.value = data.status==0?false:true;
      deviceStore.updateActiveDeviceStatusWell(
        pumpStatus.value == data.status
      );
      showToast((data.status== 1 ? ' روشن کردن پمپ ' : ' خاموش کردن پمپ ') + " با موفقیت انجام شد ", "success");
});*/
const showProgramDialog = ref(false);
const pumpStatus = ref(true);
const tableData = ref(null);
const isMobile = ref(window.innerWidth < 768);
const activeCollapseKeys = ref([]);
const dialogVisible = ref(false);
const FingerDialogVisible = ref(false);
const dialogRef = ref(null);
const title = ref(null);
const type = ref(null);
const programIndexSelected = ref(null);
const programDaySelected = ref(null);
const message = ref(null);
const userDetails = ref([]);
const dialogData = reactive({
  userLocalID: 0,
  weekDay: null,
  startTime: null,
  endTime: null,
});
//const emit = defineEmits(["update:modelValue"]);
defineExpose({
  pumpStatus
});
function handleResize() {
  isMobile.value = window.innerWidth < 768;
}
function FunShowProgram() {
  showProgramDialog.value = false;
  nextTick(() => {
    showProgramDialog.value = true;
  });
}
onMounted(() => {
  pumpStatus.value = deviceStore.activeDevice.status_well ? true : false;
  window.addEventListener("resize", handleResize);
  getWellUserDetailsFunc();
  getProgramList();
});

watch(
  () => deviceStore.activeDevice,
  (newVal) => {
    if (newVal != null) {
      pumpStatus.value = deviceStore.activeDevice.status_well ? true : false;
      getWellUserDetailsFunc();
      getProgramList();
    }
  }
);
async function getWellUserDetailsFunc() {
  if (authStore?.user?.role == 0) return;
  userDetails.value = await getWellUserDetails(
    deviceStore.activeDevice.device_id
  );
}
async function getProgramList() {
  const response = await fetchProgramList(deviceStore.activeDevice.id);
  tableData.value = response.data;
}
onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

const groupedForMobile = computed(() => {
  const map = {};

  if (!tableData.value?.length) return map;

  const data = tableData.value[0];

  // ابتدا کلیدها (روزها) را مرتب بر اساس orderedDays بگیریم
  orderedDays.forEach((day) => {
    const dayData = data[day];
    if (!dayData) return;

    const dayName = dayData.dayName || "نامشخص";

    if (!map[dayName]) {
      map[dayName] = [];
    }

    dayData.periods.forEach((period) => {
      map[dayName].push({
        startTime: period.startTime,
        endTime: period.endTime,
        userLocalID: period.user_local_id,
        day: day,
      });
    });
  });

  return map;
});
function handleRemoveProgram(index, day, period) {
  title.value = "حذف برنامه روز " + week_days[day];
  message.value =
    " آیا از حذف برنامه زمانی " +
    period.startTime +
    " تا " +
    period.endTime +
    " مطمئن هستید؟ ";

  dialogData.weekDay = day;
  dialogData.startTime = period.startTime;
  dialogData.endTime = period.endTime;
  dialogData.userLocalID = period.userLocalID;
  programIndexSelected.value = index;
  programDaySelected.value = day;
  dialogVisible.value = true;
  type.value = "program";
}
function onConfirmFingerPrint(data) {
  deviceStore.updateActiveDeviceUserLocalID(data.userLocalID);
  showToast(data.message, "success");
}
function onConfirm(data) {
  /*if (data.status == 2) {
    showToast("متاسفانه پاسخی از سمت دستگاه دریافت نشد", "error");
    return;
  }*/
  try {
    if (type.value == "program") {
      tableData.value[0][programDaySelected.value].periods.splice(
        programIndexSelected.value,
        1
      );
      programIndexSelected.value = null;
      programDaySelected.value = null;
      showToast("برنامه شما با موفقیت حذف شد", "success");
    }/*else {
      pumpStatus.value = !pumpStatus.value;
      deviceStore.updateActiveDeviceStatusWell(
        pumpStatus.value == true ? 1 : 0
      );
      showToast(title.value + " با موفقیت انجام شد ", "success");
    }*/
  } catch (err) {
    console.error("Error fetching data:", err);
  }
  title.value=null
}
function handleConfirmProgram(data) {
  tableData.value[0][data.weekDay].periods.push({
    id: 0,
    startTime: data.start,
    endTime: data.end,
    code: data.code,
    user_local_id: data.userLocalID,
  });
  showToast("برنامه شما با موفقیت ثبت شد", "success");
}
function offOnMotor() {
  title.value = pumpStatus.value ? "خاموش کردن پمپ " : "روشن کردن پمپ ";
  message.value = " آیا از  " + title.value + " مطمئن هستید؟ ";
  dialogVisible.value = true;
  type.value = "motor";
}
// در صورت نیاز به فعال کردن دستی بستن از سمت سرور:
/*function onServerResponse() {
  dialogRef.value?.allowClose();
}*/
// خروجی عکس
const exportImage = async () => {
  // باز کردن همه آیتم‌ها (مخصوص موبایل)
  if (isMobile.value) {
    activeCollapseKeys.value = Object.keys(groupedForMobile.value);
    await nextTick(); // صبر کن تا DOM آپدیت بشه
    await new Promise((resolve) => setTimeout(resolve, 500)); // صبر برای پایان انیمیشن
  }

  const tableElement = isMobile.value
    ? document.querySelector(".mobile-schedule")
    : document.querySelector(".el-table");

  if (!tableElement) return;

  html2canvas(tableElement, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#fff", // اگه بک‌گراند شفافه
  }).then((canvas) => {
    const link = document.createElement("a");
    link.download = "program.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  });
};

const exportExcel = async () => {
  if (!tableData.value?.length) return;

  const data = tableData.value[0];

  const maxPeriods = Math.max(
    ...orderedDays.map((day) => data[day]?.periods?.length || 0)
  );

  // ساخت هدر: ابتدا بازه‌ها، بعد روز هفته (آخر)
  const headers = [];
  for (let i = 1; i <= maxPeriods; i++) {
    headers.push(`بازه ${i}`);
  }
  headers.push("روز هفته");

  const rows = [];
  rows.push(headers);

  orderedDays.forEach((day) => {
    const dayData = data[day];
    if (!dayData) return;

    const row = [];

    // بازه‌ها اول
    const periods = dayData.periods || [];
    for (let i = 0; i < maxPeriods; i++) {
      if (periods[i]) {
        row.push(`${periods[i].startTime} تا ${periods[i].endTime}`);
      } else {
        row.push("-");
      }
    }

    // اسم روز هفته آخر ردیف
    row.push(dayData.dayName);

    rows.push(row);
  });

  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "برنامه زمان‌بندی");
  XLSX.writeFile(wb, "schedule.xlsx");
};
</script>

<style scoped>
.container {
  direction: rtl;
}
.top-section {
  margin-bottom: 20px;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.export-buttons {
  margin: 20px 0;
  text-align: left;
}
.table-wrapper {
  overflow-x: auto;
  background: white;
}
::v-deep(.table-wrapper .cell, .el-table .cell) {
  text-align: center !important;
  vertical-align: top !important;
}
::v-deep(.el-table .el-table__cell) {
  vertical-align: top !important;
}
::v-deep(.el-table thead tr th) {
  background: #e6edf5;
}

.time-button {
  margin: 2px 0;
  font-size: 12px;
  padding: 15px 10px;
  margin-top: 6px !important;

  width: 100%;
  text-align: center;
  cursor: pointer;
  border: 1px solid #eee;
}
.custom-card {
  direction: ltr;
  margin-bottom: 10px;
}

.card-title {
  display: flex;
  align-items: center;
  justify-content: end;
  margin-bottom: 10px;
  margin-top: 10px;
  font-weight: bold;
  font-size: 15px;
  color: #444;
}
.card-title span {
  padding-right: 10px;
}
.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-content button {
  background: #5f8cc5;
}

.pump-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pump-info p {
  margin: 0;
  font-weight: 500;
}

.pump-icon {
  width: 35px;
  height: 35px;
  background: #d2e0f0;
  border-radius: 5px;
  padding: 11px;
  margin-left: 10px;
}
.export-buttons button {
  margin: 5px;
}
.switch-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.switch-label {
  font-size: 13px;
  color: #205685;
  font-weight: 600;
}
.time-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.time-list li {
  padding: 6px 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  direction: rtl;
  width: 80%;
  margin: 0 auto;
}

.mobile-schedule {
  direction: ltr;
}

::v-deep(.mobile-collapse-item .el-collapse-item__header) {
  flex-direction: row-reverse;
  justify-content: space-between;
  font-weight: bold;
  font-size: 15px;
  color: #333;
}

::v-deep(.mobile-collapse-item .el-collapse-item__arrow) {
  margin-right: 0;
  margin-left: 8px;
  transform: rotate(180deg); /* نوک به بیرون */
  transition: transform 0.5s;
}

::v-deep(.mobile-collapse-item.is-active .el-collapse-item__arrow) {
  transform: rotate(90deg); /* هنگام باز شدن */
}
::v-deep(.el-collapse-item__title) {
  text-align: right !important;
}
.user-well-img {
  width: 20px;
  height: 20px;
  background: #d2e0f0;
  border-radius: 5px;
  padding: 11px;
  margin-left: 10px;
}
.box-user-details {
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 14px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  direction: rtl;
  margin-bottom: 10px;
}
.user-row {
  display: flex;
  justify-content: space-between;
}
@media screen and (max-width: 450px) {
  .user-row {
    display: contents;
    text-align: right;
  }
}
</style>
